import { isArray, isNullOrUndefined, isObject } from "util";


export namespace UtilFunc {
	/**
	 * 型判定
	 * @param obj
	 */
	export function typeOf(obj: any) {
		return Object.prototype.toString
			.call(obj)
			.slice(8, -1)
			.toLowerCase();
	}

	/**
	 * 距離計算
	 * @param x1
	 * @param y1
	 * @param x2
	 * @param y2
	 */
	export function getDistance(x1: number, y1: number, x2: number, y2: number) {
		return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
	}

	/**
	 * カラーコード（0xFFFFFF)を#形式('#FFF')に変える
	 */
	export function changeColorCode(code: string) {
		const code1 = code.substr(2);
		return "#" + code1;
	}

	/**
	 * 0埋めの数字を返す
	 */
	export function zeroPadding(num: number, length: number) {
		return ("0000000000" + num).slice(-length);
	}

	/**
	 * 時間差で実行
	 * @param func 
	 * @param waitMiliSecond //ミリ秒 
	 */
	export function delayStart(func: Function, waitMiliSecond: number) {
		let counter = 0;
		const waitTime = Math.floor(waitMiliSecond / createjs.Ticker.interval);
		const timer = createjs.Ticker.on("tick", () => {
			counter++;
			if (counter > waitTime) {
				func();
				createjs.Ticker.removeEventListener("tick", timer);
			}
		});
	}

	/**
	 * 待つ
	 * @param waitMiliSecond //ミリ秒
	 */
	export async function wait(waitMiliSecond: number): Promise<void> {
		return new Promise(resolve => {
			const waitTime = Math.floor(waitMiliSecond / createjs.Ticker.interval);
			let counter = 0;
			const timer = createjs.Ticker.on('tick', () => {
				counter++;
				if (counter > waitTime) {
					createjs.Ticker.off('tick', timer);
					resolve();
				}
			})
		})
	}
	/**
	 *
	 * ミリセカンドをフレーム数に変換する
	 */
	export function changeMilisecondToFrame(milisecond: number) {
		return Math.floor(milisecond / createjs.Ticker.interval);
	}

	/**
	 *  配列でないデータを配列に変換する
	 * @param obj
	 */
	export function parseArray(obj: any): Array<any> | undefined {
		const type = UtilFunc.typeOf(obj);
		if (type === "undefined") return undefined;
		if (type === "array") return obj;
		return [obj];
	}

	/**
	 * parseArrayの型指定版
	 * @param obj
	 */
	export function parseTypeArray<T>(obj: any): Array<T> {
		if (isNullOrUndefined(obj) == true) {
			// データなし
			return <Array<T>>[];
		} else if (isArray(obj) == true) {
			// 配列
			return <Array<T>>obj;
		} else {
			// 単一
			if (isObject(obj) == true && Object.keys(obj).length <= 0) {
				// 空のオブジェクトはデータなしとして扱う
				return <Array<T>>[];
			} else {
				return <Array<T>>[obj];
			}
		}
	}

	/**
	 * 型変換
	 * @param obj
	 */
	export function parseType<T>(obj: any): T | undefined {
		if (isNullOrUndefined(obj) == true) {
			// データなし
			return undefined;
		} else if (isObject(obj) == true && Object.keys(obj).length <= 0) {
			// 空のオブジェクトはデータなしとして扱う
			return undefined;
		} else {
			return <T>obj;
		}
	}

	/**
	 * 有効な文字列か
	 * @param obj
	 */
	export function isValidString(obj: any): boolean {
		const type = UtilFunc.typeOf(obj);
		if (type === "string") {
			if (obj !== "") {
				return true;
			}
			return false;
		}
		return false;
	}

	export function isValidParam(obj: object): boolean {
		// console.log("item" in obj);
		//console.log(obj);
		return true;
	}

	/**
	 * ローカルホストか
	 */
	export function isLocalHost() {
		const url = location.href;
		if (url.indexOf("localhost") > -1) {
			return true;
		}
		return false;
	}

	/**
	 * 環境取得
	 */
	export function getEnv() {
		const url = location.href;
		if (url.indexOf("localhost") > -1) {
			return 'local';
		} else if (url.indexOf("dev") > -1) {
			return 'development';
		} else {
			return 'production';
		}
	}


	export function getUrlParameter(key: string, url?: string) {
		if (!url) url = window.location.href;
		key = key.replace(/[\[\]]/g, "\\$&");
		const regex = new RegExp("[?&]" + key + "(=([^&#]*)|&|#|$)"),
			results = regex.exec(url);
		if (!results) return null;
		if (!results[2]) return '';
		// return decodeURIComponent(results[2].replace(/\+/g, " "));
		return decodeURIComponent(results[2].replace(/\+/g, " "));
	}


	/**
	 * scriptを取得
	 * @param scriptId  読み込まれるファイルのパラメータを取得する際にscriptタグのidを指定する。ナシのときは  window.location.href
	 *　サンプル <script id="townjs" src="../js/TownRoot.js?room=TOWN&bootid=0" type="text/javascript" charset="utf-8" async defer></script>
	 */
	export function getScriptParameter(scriptId: string = "") {
		//const url = document.getElementById( id );
		let url: string;
		if (scriptId != "") {
			const htmlElement = <HTMLInputElement>document.getElementById(scriptId);
			url = htmlElement.src;
		} else {
			url = window.location.href;
		}
		const parameters: Array<string> = url.split("?");
		let res: object = {};
		if (parameters.length > 1) {
			var params: Array<string> = parameters[1].split("&");
			params.forEach(param => {
				const key: string = param.split("=")[0];
				const value: string = param.split("=")[1];
				const obj: object = {};
				obj[key] = value;
				(<any>Object).assign(res, obj);
			});
			return res;
		} else {
			return false;
		}
	}

	/**
	 * ブラウザの名前を取得
	 */
	export enum BrowserName {
		'IE' = 'IntenetExplorer',
		'Edge' = 'Edge',
		'Chrome' = 'Chrome',
		'Safari' = 'Safari',
		'FireFox' = 'FireFox',
		'Opera' = 'Opera',
		'Other' = 'Other'
	}

	export function getBrowserName(): BrowserName {
		const userAgent = window.navigator.userAgent.toLowerCase();
		if (userAgent.indexOf('msie') != -1 || userAgent.indexOf('trident') != -1) {
			return BrowserName.IE
		} else if (userAgent.indexOf('edge') != -1) {
			return BrowserName.Edge;
		} else if (userAgent.indexOf('chrome') != -1) {
			return BrowserName.Chrome;
		} else if (userAgent.indexOf('safari') != -1) {
			return BrowserName.Safari;
		} else if (userAgent.indexOf('firefox') != -1) {
			return BrowserName.FireFox;
		} else if (userAgent.indexOf('opera') != -1) {
			return BrowserName.Opera;
		} else {
			return BrowserName.Other;
		}
	}

	export function isIe() {
		return (UtilFunc.getBrowserName() === BrowserName.IE)
	}

	export function isChrome() {
		return (UtilFunc.getBrowserName() === BrowserName.Chrome)
	}

	export function isFireFox() {
		return (UtilFunc.getBrowserName() === BrowserName.FireFox)
	}

	export enum UserAgent {
		"iPod" = "iPod",
		"iPad" = "iPad",
		"iPhone" = "iPhone",
		"Android" = "Android",
		"other" = "other"
	}

	//デバイス種別
	export function getUserAgent(): UserAgent {
		const ua = [
			UserAgent.iPod,
			UserAgent.iPad,
			UserAgent.iPhone,
			UserAgent.Android,
		]
		for (var i = 0; i < ua.length; i++) {
			if (navigator.userAgent.indexOf(ua[i]) > 0) {
				return ua[i]
			}
		}
		return UserAgent.other;
	}

	/**
	 * 改行を削除する
	 * @param str 
	 */
	export function removeLineBreaks(str: string) {
		if (!str || !UtilFunc.isValidString(str)) return;
		const brRegexp = /<br>|&lt;br&gt;/g;
		if (brRegexp.test(str)) {
			return str.replace(brRegexp, '');
		}
		return str.replace(/\r?\n/g, '');
	}

	/**
	 * 改行タグを置換
	 * @param str 
	 * @param useLF 
	 */
	export function replaceBreakTag(str: string, useLF: boolean): string {
		const pattern: RegExp = /&lt;br&gt;|<br>/gi;

		if (useLF == true) {
			return str.replace(pattern, "\n");
		} else {
			return str.replace(pattern, "");
		}
	}

	export function parseDate(dateStr: string) {
		dateStr = dateStr.replace(/-/g, '/');
		dateStr = dateStr.slice(0, -3);
		return dateStr;
	}


	export function isExistId(array: Array<any>, id: string) {
		const res = array.filter(obj => {
			return (obj.id === id);
		});
		if (res.length > 0) return true;
		return false;
	}

	/**
	 * スクロール制御
	 */
	function scrollListenerFunc(e) {
		e.preventDefault();
	}

	export function setEnableScroll(enable: boolean) {
		var scroll_event = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll';
		if (!enable) {
			document.addEventListener(scroll_event, scrollListenerFunc, { passive: false });
		} else {
			document.removeEventListener(scroll_event, scrollListenerFunc, { passive: false } as EventListenerOptions);
		}
	}

	export function enableScroll() {
		UtilFunc.setEnableScroll(true);
	}

	export function disableScroll() {
		UtilFunc.setEnableScroll(false);
	}

	export function createDummyRectShape(width: number, height: number): createjs.Shape {
		const dummyShape = new createjs.Shape();
		dummyShape.graphics.beginFill('#000').drawRect(0, 0, width, height);
		return dummyShape;
	}

	export function createGlowImage(origin: createjs.DisplayObject, rect: createjs.Rectangle, glowColor: string, glowStrong: number): createjs.Bitmap {
		// console.log("createGlowImage");
		// console.log(rect);
		// this.glowLayer.removeAllChildren();
		//キャッシュを生成
		origin.cache(rect.x - glowStrong, rect.y - glowStrong, rect.width + glowStrong * 2, rect.height + glowStrong * 2, 1);
		var ctx = (<HTMLCanvasElement>origin.cacheCanvas).getContext("2d");
		//cacheCanvasのctxにblurをかける
		ctx.shadowBlur = glowStrong;
		ctx.shadowColor = glowColor;

		// キャッシュを更新
		origin.updateCache();

		//仮のcanvasを作成
		var myCanvas = document.createElement("canvas");
		myCanvas.width = rect.width + glowStrong * 2;
		myCanvas.height = rect.height + glowStrong * 2;
		var myCtx = (<HTMLCanvasElement>myCanvas).getContext("2d");

		//仮のcanvasにcacheCanvasの内容を描画する
		myCtx.drawImage(<HTMLCanvasElement>origin.cacheCanvas, 0, 0);

		//仮のcanvasからbitmapを生成
		const glowImage = new createjs.Bitmap(myCanvas);

		//glowStrong分画像をずらして配置する
		glowImage.set({ x: rect.x - glowStrong, y: rect.y - glowStrong });

		origin.uncache();
		return glowImage;
	}

	export function clonePropsDisplayObject(
		src: createjs.DisplayObject,
		tgt: createjs.DisplayObject
	) {
		tgt.alpha = src.alpha;
		tgt.mouseEnabled = src.mouseEnabled;
		tgt.tickEnabled = src.tickEnabled;
		tgt.name = src.name;
		tgt.regX = src.regX;
		tgt.regY = src.regY;
		tgt.rotation = src.rotation;
		tgt.scaleX = src.scaleX;
		tgt.scaleY = src.scaleY;
		tgt.shadow = src.shadow;
		tgt.skewX = src.skewX;
		tgt.skewY = src.skewY;
		tgt.visible = src.visible;
		tgt.x = src.x;
		tgt.y = src.y;
		tgt.compositeOperation = src.compositeOperation;
		tgt.snapToPixel = src.snapToPixel;
		tgt.filters = src.filters == null ? null : src.filters.slice(0);
		tgt.mask = src.mask;
		tgt.hitArea = src.hitArea;
		tgt.cursor = src.cursor;
		const b = src.getBounds();
		if (b) {
			tgt.setBounds(b.x, b.y, b.width, b.height);
		}
	}

	var lastW: number, lastH: number, lastS: number;
	export function resizeCanvas(canvas: HTMLCanvasElement, w: number, h: number) {
		var iw = window.innerWidth, ih = window.innerHeight;
		var cw = document.documentElement.clientWidth;
		var ch = document.documentElement.clientHeight;
		//alert("iw:"+ iw + ",cw:" + cw);
		if (iw > cw) iw = cw;
		if (ih > ch) ih = ch;

		var pRatio = window.devicePixelRatio, xRatio = iw / w, yRatio = ih / h, sRatio = 1;
		sRatio = Math.min(xRatio, yRatio);
		// console.log(sRatio );
		// canvas.style.width = w * sRatio + 'px';
		canvas.style.height = h * sRatio + 'px';

		// console.log(canvas.style.width);
		// console.log(canvas.style.height);

		lastW = iw; lastH = ih; lastS = sRatio;
	}

	export function playBgm(soundId: string) {
		createjs.Sound.play(soundId, { interrupt: createjs.Sound.INTERRUPT_EARLY, loop: -1 })
	}

	export function stopBgm(soundId: string) {
		createjs.Sound.stop();
	}

	export function getUuid(): string {
		return localStorage.getItem("uuid");
	}

	/**
	 * ニックネーム取得
	 */
	export function getName(): string {
		return localStorage.getItem("name");
	}

	/**
	 * 年齢取得
	 */
	export function getAge(): string {
		return localStorage.getItem("age");
	}

	/**
	 * ハッシュ取得
	 */
	export function getHash(): string {
		return localStorage.getItem("hash");
	}

}
